import MainContainer from "../shared/containers/MainContainer";
import ModernAppBar from "./ModernAppBar";
import React from "react";
import TabMenu from "./TabMenu";
import { Box } from "@mui/material";

interface ModernLayoutProps {
  children: React.ReactNode;
}

export default function ModernLayout({ children }: ModernLayoutProps) {
  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: "column",
        minHeight: "100vh",
        backgroundColor: "#f9f5ef", // Zgodnie z wytycznymi
      }}
    >
      {/* Połączony AppBar + TabMenu w centralnym kontenerze */}
      <Box
        sx={{
          width: "100%",
          display: "flex",
          justifyContent: "center",
          backgroundColor: "#f9f5ef",
        }}
      >
        <Box sx={{ width: "100%", maxWidth: "1200px" }}>
          <ModernAppBar />
          <TabMenu />
        </Box>
      </Box>

      {/* Główna zawartość */}
      <Box
        sx={{
          flex: 1,
          pb: 4,
          display: "flex",
          justifyContent: "center",
        }}
      >
        <Box sx={{ width: "100%", maxWidth: "1200px" }}>
          <MainContainer noPadding>{children}</MainContainer>
        </Box>
      </Box>
    </Box>
  );
}
